export default "__VITE_ASSET__BAOKr7Wr__"